import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance } from './BufferOverflow.mjs';
import { CoroutineStart_DEFAULT_getInstancexcjy3fsqr6w6 as CoroutineStart_DEFAULT_getInstance } from '../CoroutineStart.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../CoroutineScope.mjs';
import {
  SendChannel38sllbxw662ws as SendChannel,
  Channel3r72atmcithql as Channel,
} from './Channel.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { newCoroutineContext2tdpc8c02iv5t as newCoroutineContext } from '../CoroutineContext.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ChannelCoroutine12l2gxei4u780 as ChannelCoroutine } from './ChannelCoroutine.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from '../CoroutineExceptionHandler.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function produce(_this__u8e3s4, context, capacity, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  return produce_0(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
}
var ProducerScopeClass;
function ProducerScope() {
  if (ProducerScopeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ProducerScope', VOID, VOID, [CoroutineScope(), SendChannel()], [1]);
    ProducerScopeClass = $;
  }
  return ProducerScopeClass;
}
function produce_0(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  onCompletion = onCompletion === VOID ? null : onCompletion;
  var channel = Channel(capacity, onBufferOverflow);
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = new (ProducerCoroutine())(newContext, channel);
  if (!(onCompletion == null)) {
    coroutine.gx(onCompletion);
  }
  coroutine.rw(start, coroutine, block);
  return coroutine;
}
var ProducerCoroutineClass;
function ProducerCoroutine() {
  if (ProducerCoroutineClass === VOID) {
    class $ extends ChannelCoroutine() {
      constructor(parentContext, channel) {
        super(parentContext, channel, true, true);
      }
      ew() {
        return super.ew();
      }
      x1c(value) {
        this.e1c_1.q1b();
      }
      fw(value) {
        return this.x1c(value instanceof Unit() ? value : THROW_CCE());
      }
      gw(cause, handled) {
        var processed = this.e1c_1.o1b(cause);
        if (!processed && !handled) {
          handleCoroutineException(this.cw_1, cause);
        }
      }
      s1b(cause, $super) {
        return this.ox(cause, ($super == null ? true : $super instanceof ProducerCoroutine()) ? $super : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ProducerCoroutine', VOID, VOID, [ProducerScope()], [1, 0]);
    ProducerCoroutineClass = $;
  }
  return ProducerCoroutineClass;
}
//region block: exports
export {
  ProducerScope as ProducerScopeb3mmhvfa6ll7,
  produce_0 as produce3s4oh9balbl5b,
  produce as produce1iljho2c8bp6o,
};
//endregion

//# sourceMappingURL=Produce.mjs.map
